import { BrowserRouter, Route, Switch} from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './app.css';

//import $ from 'jquery'; // se ocupa aquí sino no funciona la rutina de quitar f5 en homeProcess

//libreria de componete base de Marco Ibarra
import GlobalStyle from '@reactjscomponentrepository/frontend-components/lib/styles/globalStyles';

//carpetas básicas

//import Home from './views/home/home'; 
//import HomeProcess from './views/homeProcess/homeProcess';

import Autenticar from './vistas/autenticar/Autenticar'; 
import PaginaSSC from './vistas/paginaSSC/PaginaSSC'; 
import Ayuda from './vistas/paginaSSC/Ayuda'; 

//para ejemplos de componentes
import Ejemplo from './vistas/componentes/tuplasCatalogo/Ejemplo';
import Ejemplo1 from './vistas/componentes/generaMenu/Ejemplo';
import Ejemplo2 from './vistas/componentes/generaComboFecha/Ejemplo';
import Ejemplo3 from './vistas/componentes/generaMenuVertical/Ejemplo';
import Ejemplo4 from './vistas/componentes/generaDropzone/Ejemplo';
import Ejemplo5 from './vistas/componentes/generaDropzone/Ejemplo2';
import Ejemplo6 from './vistas/componentes/generaSlidingPanel/Ejemplo';
import Ejemplo7 from './vistas/componentes/generaRuta/Ejemplo';
import Ejemplo8 from './vistas/componentes/cuestionario/Ejemplo';
import Ejemplo9 from "./vistas/componentes/generaStepper/Ejemplo";
import Ejemplo10 from "./vistas/componentes/cargaAPI/Ejemplo";
import Ejemplo11 from "./vistas/componentes/generaSemaforo/Ejemplo";
import Ejemplo12 from "./vistas/componentes/generaCorreo/Ejemplo";
import Ejemplo13 from "./vistas/componentes/generaExportacionExcel/Ejemplo";
//import Ejemplo14 from "./vistas/componentes/generaGrafica/Ejemplo";
import Ejemplo15 from "./vistas/componentes/generaDropzone/Ejemplo3";

import configurarValidaciones from './../src/validaciones'; //para cuestionario

configurarValidaciones();
//
const App = () => {
    const routes = [
        //{path: '/home', component: Home, exact: true},
        //{path: '/homeProcess', component: HomeProcess, exact: true},
        //{path: '/homeProcess/content',   component: HomeProcess, exact: true},

        {path: '/home', component: Autenticar, exact: true},
        {path: '/autenticar/autenticar', component: Autenticar, exact: true},
        {path: '/paginaSSC', component: PaginaSSC, exact: true},
        {path: '/paginaSSC/contenido', component: PaginaSSC, exact: true},
        {path: '/Ayuda', component: Ayuda, exact: true},
       

        {path: '/componentes/tuplasCatalogo', component: Ejemplo, exact: true},
        {path: '/componentes/generaMenu', component: Ejemplo1, exact: true},
        {path: '/componentes/cargaComboFecha', component: Ejemplo2, exact: true},
        {path: '/componentes/generaMenuVertical', component: Ejemplo3, exact: true},
        {path: '/componentes/generaDropzone', component: Ejemplo4, exact: true},
        {path: '/componentes/generaDropzoneOriginal', component: Ejemplo15, exact: true},
        {path: '/componentes/generaDropzoneUnArchivo', component: Ejemplo5, exact: true},
        {path: '/componentes/generaSlidingPanel', component: Ejemplo6, exact: true},
        {path: '/componentes/generaRuta', component: Ejemplo7, exact: true},
        {path: '/componentes/cuestionario', component: Ejemplo8, exact: true},
        {path: '/componentes/generaStepper', component: Ejemplo9, exact: true },
        {path: '/componentes/cargaAPI', component: Ejemplo10, exact: true },
        {path: '/componentes/generaSemaforo', component: Ejemplo11, exact: true },
        {path: '/componentes/generaCorreo', component: Ejemplo12, exact: true },
        {path: '/componentes/generaExportacionExcel', component: Ejemplo13, exact: true },
        //{path: '/componentes/generaGraficas', component: Ejemplo13, exact: true },
        {path: '/', component: Autenticar, exact: true},
        {path: '/', component: Autenticar, exact: true},
        {path: '*', component: Autenticar},
      ];
    const basename = process.env.REACT_APP_BASE_NAME;  
    
    return (
        <div className="">{/*  */}
            <GlobalStyle />

            <BrowserRouter basename={basename}>
              <Switch>
                {routes.map((route) => (
                  <Route key={route.path} path={route.path} exact={route.exact}>
                    <route.component />
                  </Route>
                ))}
              </Switch>
            </BrowserRouter>
            <ToastContainer position="top-right" theme='colored' />
        </div>
       
    )
}
export default App;
